module.exports = __webpack_public_path__ + "assets/images/pages/job/full-stack-developer-card.png?bb8e59a5";